import React from "react"; // Importing React library
import Theme from '../../../styles/Theme/Theme'; // Importing Theme
import styled from "styled-components"; // Importing styled-components library
import CustomIcon from "../Icons/CustomIcon"; // Importing CustomIcon component
import { Text } from "./Text"; // Importing Text component

//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
// Styled component for the wrapper of the mouseover tooltip
const MouseoverTooltipWrapper = styled.div`
    height: auto;
    width: auto;
`;

// Styled component for the header of the mouseover tooltip
const MouseoverTooltipHeader = styled.div`
    display: flex;
    align-items: center;
    margin-bottom:${Theme.spacing.s03}; // Using Theme for spacing
    min-width: 280px; // Setting minimum width
`;

// Styled component for the content of the mouseover tooltip
const MouseoverTooltipContent = styled.div`
    display: flex;
    align-items: center;
    margin-top:${Theme.spacing.s02}; // Using Theme for spacing
    margin-bottom:  ${Theme.spacing.s02}; // Using Theme for spacing
`;
//#endregion 

// Functional component for the mouseover tooltip
const MouseoverTooltip = ({ data }) => {
    try {
        return (
            <>
                <MouseoverTooltipWrapper>
                    {/* Rendering header */}
                    {data && data.header?.length ?
                        data.header.map((val, key) => {
                            return (<MouseoverTooltipHeader key={key}>
                                {val.icon ? <CustomIcon icon={val.icon} iconsize='xs' color={'blue-4'} /> : null}
                                <Text textcolor='coolgray-12' textsize='text_sm' textweight='medium' textmarginright='s08' textmarginleft={val.icon ? 's02' : null}>{val.title}</Text>
                            </MouseoverTooltipHeader>)
                        })
                        : null
                    }
                    {/* Rendering icon-text pairs */}
                    {data && data.iconText?.length ?
                        data.iconText.map((val, key) => {
                            return (<MouseoverTooltipContent key={key}>
                                {val.icon ? <CustomIcon icon={val.icon} iconsize='xs' color={'blue-4'} /> : null}
                                <Text textcolor='coolgray-12' textsize='text_xs' textweight='regular' textmarginleft={val.icon ? 's02' : null}>{val.text}</Text>
                            </MouseoverTooltipContent>)
                        })
                        : null
                    }
                </MouseoverTooltipWrapper>
            </>
        )
    } catch (error) {
        console.error('(MouseoverTooltip page) Error rendering MouseoverTooltip:', error);
        //reportError(error); // Send error report to backend
    }
}

export default MouseoverTooltip; // Exporting the MouseoverTooltip component

// DATA STRUCTURE EXAMPLE

// const DUMMY_DATA =
//   {
//     header: [
//       {icon: "Lamp", title: "Titulo"}
//     ],
//     iconText: [
//       {icon: "Calendar", text: "04-02-2022"},
//       {icon: null, text: "Descrição breve"},
//     ],
//   }